import Text from '../../../components/atoms/Text';
import Heading from '../../../components/atoms/Heading';
import PrimaryButton from '../../../components/atoms/Button';
import useMediaQuery from '../../../hooks/useMediaQuery';
import { Check } from '@phosphor-icons/react';

const ProductCardSimple = ({
	name,
	price,
	description,
	benefitsTitle = 'Beneficios incluidos',
	benefits,
	ctaLabel,
	ctaAction,
	className,
	imgBanner,
	stylesDescription,
	isLoading,
	discount,
	priceDescription,
	type = 'primary',
	customContent,
	customButtonIcon,
	isAdquired,
	extraInfo,
	badge,
}: {
	name: React.ReactNode;
	price?: string | number;
	description: string;
	benefits: string[];
	benefitsTitle?: string;
	ctaAction: () => void;
	ctaLabel: string;
	className?: string;
	imgBanner: string;
	stylesDescription?: string;
	isLoading?: boolean;
	discount?: string;
	priceDescription?: string;
	type?: 'primary' | 'green' | 'danger';
	customButtonIcon?: React.ReactNode;
	customContent?: React.ReactNode;
	isAdquired?: boolean;
	extraInfo?: React.ReactNode;
	badge?: React.ReactNode;
}) => {
	const isMobile = useMediaQuery('(max-width: 768px)');
	const buttonStyle = {
		isAdquired: `disabled:!text-white !bg-h-success-90 !text-h-success-30 !cursor-not-allowed ${isLoading ? '!text-h-dark' : ''}`,
		primary: 'disabled:!text-white !bg-h-primary',
		green: `disabled:!text-white !bg-[#6BA233]`,
		danger: `disabled:!text-white !bg-h-error-30`,
	};
	return (
		<div
			className={`bg-white shadow p-4 rounded-2xl flex flex-col gap-6 justify-start relative ${className} overflow-hidden`}
		>
			{badge}
			{imgBanner && (
				<img
					src={imgBanner}
					alt={description}
					className='size-32 absolute -top-7 -right-4'
				/>
			)}
			<Heading
				size='xs'
				weight='bold'
				color='dark'
				sx='text-left mt-1 pr-28'
			>
				{name}
			</Heading>

			<div>
				{price && (
					<div className='flex gap-2 items-center'>
						<Heading
							size='s'
							weight='bold'
							color='dark'
							responsive={isMobile}
							sx='text-left -my-2'
						>
							${price}
						</Heading>
						<Text
							color='medium'
							sx={`mt-2 line-through`}
						>
							{discount}
						</Text>
					</div>
				)}
				{priceDescription && (
					<Text
						size='caption'
						color='medium'
						sx={`mt-2 !text-h-success-50`}
						weight='light'
					>
						{priceDescription}
					</Text>
				)}
			</div>

			<Text
				color='dark'
				weight='light'
				sx={`min-h-[100px] -mt-4 ${stylesDescription}`}
			>
				{description}
			</Text>
			{customContent && customContent}

			{isAdquired ? (
				<PrimaryButton
					label={'Adquirida'}
					beforeIcon={
						<Check
							weight='bold'
							className='size-4'
						/>
					}
					onClick={() => {}}
					loading={isLoading}
					color='green'
					sx='disabled:!text-white !bg-h-success-90 !text-h-success-30 !cursor-not-allowed'
				/>
			) : (
				<PrimaryButton
					label={isAdquired ? 'Adquirida' : ctaLabel}
					beforeIcon={
						<>
							{isAdquired && (
								<Check
									weight='bold'
									className='size-4'
								/>
							)}
							{customButtonIcon && customButtonIcon}
						</>
					}
					onClick={isAdquired ? () => {} : ctaAction}
					loading={isLoading}
					color={isAdquired ? 'green' : 'primary'}
					sx={`${isAdquired && buttonStyle.isAdquired} ${buttonStyle[type]}`}
				/>
			)}

			{extraInfo && extraInfo}

			<hr />

			<Text
				size='caption'
				weight='bold'
				color='medium'
			>
				{benefitsTitle}
			</Text>

			<div className='flex flex-col gap-2'>
				{benefits.map((benefit, index) => (
					<div
						key={index}
						className='flex items-center gap-2 border-b border-h-neutral-90 pb-2'
					>
						<Check
							className='text-h-primary min-w-[14px]'
							size={14}
							weight='bold'
						/>
						<Text
							size='caption'
							color='dark'
							weight='light'
						>
							{benefit}
						</Text>
					</div>
				))}
			</div>
		</div>
	);
};

export default ProductCardSimple;
